import type { CheckboxProperties, FormElement } from '../../model/form.types';
import type { ColumnDef, FieldDefinition, FieldValue, SelectOption, ValidationIssue } from '../../model/types';
import {
  normalizeOption,
  selectedStrings,
  selectionShapeIssue,
  validateSelection,
} from './shared';

type CheckboxElement = FormElement & { properties: CheckboxProperties };

function options(element: CheckboxElement): SelectOption[] {
  return (element.properties.options ?? []).map((option) => ({
    value: option.text,
    label: option.text,
  }));
}

function shapeIssue(element: CheckboxElement, value: FieldValue): ValidationIssue | null {
  return selectionShapeIssue(element, value, element.properties.multipleSelection === true);
}

export const checkboxDefinition: FieldDefinition<CheckboxElement> = {
  kind: 'field',
  type: 'CHECKBOX',
  emptyValue: () => [],
  control: (element) => ({
    kind: 'checkbox',
    options: options(element),
    multiple: element.properties.multipleSelection === true,
  }),
  shapeIssue,
  validate: (element, value) =>
    validateSelection(
      element,
      value,
      options(element).map((option) => option.value),
      element.properties.multipleSelection === true,
    ),
  columns: (element, label): ColumnDef[] =>
    options(element).map((option) => ({
      key: `${element.id}::${option.value}`,
      fieldId: element.id,
      label: `${label} / ${option.label}`,
    })),
  cells: (element, value) => {
    const selected = new Set(selectedStrings(value));
    return options(element).map((option) => (selected.has(option.value) ? 'Sim' : 'Não'));
  },
  triggerMatches: (_element, value, option) =>
    selectedStrings(value).some((item) => normalizeOption(item) === normalizeOption(option)),
};
